import request from "../request";
import qs from "qs";

export function getAircraftStatisticsData(data) {
  return request.post({
    url: "/fly-car/static",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export function getEmergencyStatisticsData(data) {
  return request.post({
    url: "/rescue/static",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export function getAlarmStatisticsData(data) {
  return request.post({
    url: "/warning_info/static",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export function getRegisterUserStatisticsData(data) {
  return request.post({
    url: "/auth/static",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

export function exportAircraftExcelData(params) {
  return request.get({
    url: "/fly-car/export",
    params: params,
    responseType: 'arraybuffer',
  });
}
export function exportEmergencyExcelData(params) {
  return request.get({
    url: "/rescue/export",
    params: params,
    responseType: 'arraybuffer',
  });
}
export function exportAlarmExcelData(params) {
  return request.get({
    url: "/warning_info/export",
    params: params,
    responseType: 'arraybuffer',
  });
}
export function exportRegisterUserExcelData(params) {
  return request.get({
    url: "/auth/export",
    params: params,
    responseType: 'arraybuffer',
  });
}
